import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/configuration/app.constants';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics-ecommerce/google-analytics-ecommerce.service';
import { HttpService } from 'src/app/services/http/http.service';
declare var $: any
@Component({
  selector: 'app-wedding-testimonial',
  templateUrl: './wedding-testimonial.component.html',
  styleUrls: ['./wedding-testimonial.component.less']
})
export class WeddingTestimonialComponent implements OnInit {

  @Input("type") type: any;

  getdata2
  getdata
  imgPth
  desert: any = [];
  wedding: any =[];
  custom: any = [];

  constructor(
    public http: HttpService,
    public router : Router,
    public analyticsService:GoogleAnalyticsService
  ) { }

  ngOnInit(): void {
    this.analyticsService.pageView("Testimonial wedding View","testimonial/wedding",window.location.origin);
    this.imgPth = AppConstants.SERVER_CONFIG.IMG_URL;
    this.getwedding('wedding');
  }



  //get all testmonial

  getwedding(value){
    this.http.get(`/admin/testimonial/fetch/${value}`).subscribe(
      data => {
     
        this.getdata2 = data;
        this.wedding = this.getdata2.content.filter((x) => x?.pageType == 'wedding');
  
        setTimeout(() => {
          this.refreshSlider();
        }, 200);
      },
      error => {

      });
  }

  //refresh owl slider after 200ms
  refreshSlider() {
    $(".test-1 #owl-testimonial").owlCarousel({
      items: 3,
      nav: false,
      dots: false,
      loop: true,
      responsive: {
        0: {
          items: 1,
          navigation: true,
          margin: 5,
          nav: true,
        },
        801: {
          items: 1,
          navigation: true,
          nav: true,
          margin: 50,
        },
        1025: {
          items: 3,
        }
      },
    });
  }
toViewPage(){
this.router.navigateByUrl('testimonial/wedding')
}
}
